export enum RegexConfig {
  EMAIL = '^^[a-zA-Z0-9._{|}-]*@[a-zA-Z0-9]+.^[A-Za-z]+${2,}$',
  MOBILE = '^[0-9]*$',
  NEW_MOBILE = '^[0-9]{10}$',
  PAN = '^[A-Z]{5}[0-9]{4}[A-Z]{1}$',
  AADHAR = '^[2-9]{1}[0-9]{11}$',
  ONLY_NUMBER = '^[0-9]*$',
  NEW_EMAIL = '^[\\w-\\.]+@([\\w-]+\\.)+[\\w-]{2,4}$',
  IFSC = '^[A-Z]{4}0[A-Z0-9]{6}$',
  NAME = '^(?!.*[\uD83C-\uDBFF\uDC00-\uDFFF]).*$\n',
}

export enum LENDER_ID {
  TATA = 'tata',
  MIRAE = 'mirae',
  BAJAJ = 'bajaj',
  NUVAMA = 'nuvama',
  DSP = 'dsp',
}

export enum PLATFORM_NAME {
  TDL = 'TATADIGITAL',
  PHONEPE = 'PHONEPE',
  CHOICE = 'CHOICE',
  MOBIKWIK = 'MOBIKWIK',
  REDVISION = 'REDVISION'
}

export enum DSP_PAYMENT_STATUS {
  SUCCESS = 'SUCCESS',
  IN_PROGRESS = 'IN_PROGRESS',
  FAILED = 'FAILED',
  CANCELLED = 'CANCELLED',
  EXEEDED = 'EXEEDED',
}

export declare enum KeyboardType {
  default = 'default',
  numberPad = 'number-pad',
  decimalPad = 'decimal-pad',
  numeric = 'numeric',
  email = 'email-address',
  phone = 'phone-pad',
  url = 'url',
}
